var _path, _path2, _path3, _g, _rect, _path4, _path5, _path6, _path7, _g2, _rect2, _path8, _path9, _path10, _path11, _g3, _rect3, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMembership(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 734,
    height: 572,
    viewBox: "0 0 734 572",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M263.426 388.596L212.347 363.869L154.703 432.613L145.024 418.874L157.072 326.462L109.355 182.837L0 221.552L29.1267 294.877L122.733 520.219L143.377 571.275L145.769 556.452L168.578 469.479L200.457 434.08L257.379 429.703L166.728 366.96L263.426 388.596Z",
    fill: "#2A72DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M175.366 118.176C209.183 118.176 236.598 91.7215 236.598 59.0881C236.598 26.4546 209.183 0 175.366 0C141.549 0 114.135 26.4546 114.135 59.0881C114.135 91.7215 141.549 118.176 175.366 118.176Z",
    fill: "#0047AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M336.977 474.125L299.729 492.829C288.899 472.23 265.932 458.581 239.919 460.656C209.483 463.093 185.207 487.572 183.944 517.014C183.47 528.002 186.087 538.38 191.096 547.359L188.569 548.623L168.67 558.595L143.401 571.274C130.361 541.832 119.328 512.277 110.011 483.105C108.499 478.435 107.033 473.719 105.634 469.049V469.004C104.596 465.575 103.558 462.055 102.768 459.325C101.979 456.618 101.437 454.745 101.437 454.745C84.7194 396.424 74.4991 340.495 68.3624 291.424L68.4076 292.372C60.2404 238.518 59.8343 179.881 59.8343 179.881C59.5635 170.134 59.4958 161.313 59.4958 153.529C59.4958 148.814 59.4959 144.46 59.5861 140.534C59.8343 124.922 60.3983 115.694 60.466 114.385V114.227L93.0897 118.649L109.559 121.402C109.447 122.846 109.379 124.312 109.379 125.779C109.379 158.425 136.791 184.867 170.588 184.867C198.789 184.867 222.501 166.502 229.608 141.482L247.206 144.415L274.054 149.13V149.243C273.986 150.168 273.264 163.343 273.354 184.529C273.354 184.529 274.911 244.271 277.438 267.328C280.619 300.02 285.989 336.231 295.081 371.629C295.126 371.742 295.149 371.832 295.171 371.945C298.601 385.866 299.074 386.294 299.097 386.294C308.212 417.812 320.485 448.135 337 474.103L336.977 474.125Z",
    fill: "#6495ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_229)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 178,
    width: 273,
    height: 56,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 176.233L346.322 171L394.5 238.413L387.178 243.646L339 176.233Z",
    fill: "#4B4B4B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343 176.233L350.322 171L398.5 238.413L391.178 243.646L343 176.233Z",
    fill: "#4B4B4B",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343 176.233L512.69 54.9618L611.6 193.362L441.909 314.633L343 176.233Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.541 214L497.637 208.94H495.965V214H492.445V198.6H498.605C501.531 198.6 503.885 200.954 503.885 203.88C503.885 205.772 502.741 207.488 501.047 208.346L504.325 214H500.541ZM495.965 201.9V205.86H498.605C499.573 205.86 500.365 205.002 500.365 203.88C500.365 202.758 499.573 201.9 498.605 201.9H495.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.299 210.612H490.459V214H480.779V198.6H490.349V201.988H484.299V204.54H489.799V207.884H484.299V210.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.613 198.6H478.133V214H474.613V198.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.072 198.6V201.988H469.112V214H465.592V201.988H461.632V198.6H473.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.793 214L448.889 208.94H447.217V214H443.697V198.6H449.857C452.783 198.6 455.137 200.954 455.137 203.88C455.137 205.772 453.993 207.488 452.299 208.346L455.577 214H451.793ZM447.217 201.9V205.86H449.857C450.825 205.86 451.617 205.002 451.617 203.88C451.617 202.758 450.825 201.9 449.857 201.9H447.217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.551 210.612H441.711V214H432.031V198.6H441.601V201.988H435.551V204.54H441.051V207.884H435.551V210.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.203 214L416.188 198.6H420.037L423.448 209.93L426.858 198.6H430.708L425.692 214H421.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.768 210.612H417.268V214H408.248V198.6H411.768V210.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.082 198.6H405.602V214H402.082V198.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.71 214.308C391.476 214.308 389.408 212.768 388.55 210.502L391.586 208.742C392.136 210.018 393.082 210.876 394.82 210.876C396.492 210.876 396.91 210.216 396.91 209.622C396.91 208.676 396.03 208.302 393.72 207.664C391.432 207.026 389.188 205.926 389.188 202.978C389.188 200.008 391.696 198.292 394.358 198.292C396.888 198.292 398.868 199.502 399.99 201.768L397.02 203.506C396.492 202.406 395.766 201.724 394.358 201.724C393.258 201.724 392.708 202.274 392.708 202.89C392.708 203.594 393.082 204.078 395.48 204.804C397.812 205.508 400.43 206.322 400.43 209.578C400.43 212.548 398.054 214.308 394.71 214.308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.678 204.825C328.078 205.253 324.23 202.544 323.493 202.538C322.756 202.533 318.864 205.178 318.271 204.742C317.678 204.305 319.072 199.818 318.85 199.117C318.628 198.417 314.901 195.543 315.135 194.846C315.368 194.149 320.078 194.084 320.678 193.657C321.278 193.23 322.867 188.808 323.604 188.814C324.341 188.82 325.858 193.267 326.451 193.703C327.044 194.14 331.752 194.281 331.974 194.982C332.196 195.682 328.424 198.495 328.19 199.193C327.957 199.89 329.278 204.398 328.678 204.825Z",
    fill: "url(#paint0_linear_1_229)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 260.5,
    y: 178.5,
    width: 272,
    height: 55,
    rx: 9.5,
    stroke: "url(#paint1_linear_1_229)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M311.217 206.28L304.214 202.889L296.31 212.315L294.983 210.431L296.635 197.761L290.093 178.068L275.099 183.377L279.093 193.43L291.927 224.326L294.757 231.327L295.085 229.294L298.213 217.369L302.584 212.516L310.388 211.916L297.959 203.313L311.217 206.28Z",
    fill: "#010101",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M299.144 169.203C303.781 169.203 307.539 165.576 307.539 161.101C307.539 156.627 303.781 153 299.144 153C294.507 153 290.749 156.627 290.749 161.101C290.749 165.576 294.507 169.203 299.144 169.203Z",
    fill: "#C2C2C2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M321.301 218.006L316.194 220.571C314.709 217.747 311.56 215.875 307.994 216.16C303.821 216.494 300.492 219.85 300.319 223.887C300.254 225.393 300.613 226.816 301.3 228.048L300.953 228.221L298.225 229.588L294.76 231.326C292.972 227.29 291.46 223.237 290.182 219.238C289.975 218.597 289.774 217.951 289.582 217.31V217.304C289.44 216.834 289.298 216.352 289.189 215.977C289.081 215.606 289.007 215.349 289.007 215.349C286.715 207.353 285.313 199.685 284.472 192.957L284.478 193.086C283.358 185.703 283.303 177.663 283.303 177.663C283.266 176.327 283.256 175.117 283.256 174.05C283.256 173.403 283.256 172.806 283.269 172.268C283.303 170.128 283.38 168.862 283.389 168.683V168.661L287.862 169.268L290.12 169.645C290.105 169.843 290.096 170.044 290.096 170.245C290.096 174.721 293.854 178.347 298.488 178.347C302.355 178.347 305.606 175.829 306.58 172.398L308.993 172.8L312.674 173.447V173.462C312.665 173.589 312.566 175.396 312.578 178.3C312.578 178.3 312.792 186.491 313.138 189.653C313.574 194.135 314.31 199.1 315.557 203.953C315.563 203.969 315.566 203.981 315.569 203.997C316.04 205.905 316.105 205.964 316.108 205.964C317.357 210.285 319.04 214.443 321.304 218.003L321.301 218.006Z",
    fill: "#626365"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.227 211.009C330.769 211.009 336.883 204.895 336.883 197.354C336.883 189.812 330.769 183.698 323.227 183.698C315.686 183.698 309.572 189.812 309.572 197.354C309.572 204.895 315.686 211.009 323.227 211.009ZM323.227 211.509C331.045 211.509 337.383 205.171 337.383 197.354C337.383 189.536 331.045 183.198 323.227 183.198C315.41 183.198 309.072 189.536 309.072 197.354C309.072 205.171 315.41 211.509 323.227 211.509Z",
    fill: "url(#paint2_linear_1_229)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_229)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 281,
    width: 273,
    height: 56,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437 279.233L444.322 274L492.5 341.413L485.178 346.646L437 279.233Z",
    fill: "#F8B42B",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441 279.233L448.322 274L496.5 341.413L489.178 346.646L441 279.233Z",
    fill: "#FAC730",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441 279.233L588.168 174.058L695.306 323.973L548.139 429.148L441 279.233Z",
    fill: "#FAC730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.387 319L591.483 313.94H589.811V319H586.291V303.6H592.451C595.377 303.6 597.731 305.954 597.731 308.88C597.731 310.772 596.587 312.488 594.893 313.346L598.171 319H594.387ZM589.811 306.9V310.86H592.451C593.419 310.86 594.211 310.002 594.211 308.88C594.211 307.758 593.419 306.9 592.451 306.9H589.811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.145 315.612H584.305V319H574.625V303.6H584.195V306.988H578.145V309.54H583.645V312.884H578.145V315.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.459 303.6H571.979V319H568.459V303.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.918 303.6V306.988H562.958V319H559.438V306.988H555.478V303.6H566.918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.619 303.6C545.865 303.6 549.099 306.944 549.099 311.3C549.099 315.656 545.865 319 541.619 319H535.459V303.6H541.619ZM541.619 315.612C544.039 315.612 545.711 313.94 545.711 311.3C545.711 308.66 544.039 306.988 541.619 306.988H538.979V315.612H541.619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.408 315.612H533.908V319H524.888V303.6H528.408V315.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.899 319.308C510.477 319.308 506.891 315.832 506.891 311.3C506.891 306.768 510.477 303.292 514.899 303.292C519.321 303.292 522.907 306.768 522.907 311.3C522.907 315.832 519.321 319.308 514.899 319.308ZM514.899 315.876C517.407 315.876 519.387 314.05 519.387 311.3C519.387 308.55 517.407 306.724 514.899 306.724C512.391 306.724 510.411 308.55 510.411 311.3C510.411 314.05 512.391 315.876 514.899 315.876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.566 310.42V311.74C505.566 316.448 502.288 319.308 497.976 319.308C493.136 319.308 489.66 315.744 489.66 311.322C489.66 306.856 493.202 303.292 497.734 303.292C500.682 303.292 503.168 304.744 504.466 306.812L501.474 308.528C500.836 307.516 499.45 306.724 497.712 306.724C495.116 306.724 493.18 308.638 493.18 311.344C493.18 313.962 495.028 315.876 498.02 315.876C500.066 315.876 501.408 314.974 501.958 313.5H497.844V310.42H505.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1_229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.678 307.825C426.078 308.253 422.23 305.544 421.493 305.538C420.756 305.533 416.864 308.178 416.271 307.742C415.678 307.305 417.072 302.818 416.85 302.117C416.628 301.417 412.901 298.543 413.135 297.846C413.368 297.149 418.078 297.084 418.678 296.657C419.278 296.23 420.867 291.808 421.604 291.814C422.341 291.82 423.858 296.267 424.451 296.703C425.044 297.14 429.752 297.281 429.974 297.982C430.196 298.682 426.424 301.495 426.19 302.193C425.957 302.89 427.278 307.398 426.678 307.825Z",
    fill: "url(#paint3_linear_1_229)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.678 307.825C426.078 308.253 422.23 305.544 421.493 305.538C420.756 305.533 416.864 308.178 416.271 307.742C415.678 307.305 417.072 302.818 416.85 302.117C416.628 301.417 412.901 298.543 413.135 297.846C413.368 297.149 418.078 297.084 418.678 296.657C419.278 296.23 420.867 291.808 421.604 291.814C422.341 291.82 423.858 296.267 424.451 296.703C425.044 297.14 429.752 297.281 429.974 297.982C430.196 298.682 426.424 301.495 426.19 302.193C425.957 302.89 427.278 307.398 426.678 307.825Z",
    fill: "url(#paint4_linear_1_229)"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 358.25,
    y: 281.25,
    width: 272.5,
    height: 55.5,
    rx: 9.75,
    stroke: "url(#paint5_linear_1_229)",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M409.217 309.581L402.214 306.191L394.31 315.617L392.983 313.733L394.635 301.062L388.093 281.37L373.099 286.678L377.093 296.732L389.927 327.628L392.757 334.628L393.085 332.596L396.213 320.671L400.584 315.818L408.388 315.218L395.959 306.615L409.217 309.581Z",
    fill: "#010101",
    fillOpacity: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M397.144 272.505C401.781 272.505 405.539 268.878 405.539 264.403C405.539 259.929 401.781 256.302 397.144 256.302C392.507 256.302 388.749 259.929 388.749 264.403C388.749 268.878 392.507 272.505 397.144 272.505Z",
    fill: "#C2C2C2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M419.301 321.308L414.194 323.873C412.709 321.048 409.56 319.177 405.994 319.462C401.821 319.796 398.492 323.152 398.319 327.189C398.254 328.695 398.613 330.118 399.3 331.349L398.953 331.522L396.225 332.89L392.76 334.628C390.972 330.591 389.46 326.539 388.182 322.539C387.975 321.899 387.774 321.253 387.582 320.612V320.606C387.44 320.136 387.298 319.653 387.189 319.279C387.081 318.908 387.007 318.651 387.007 318.651C384.715 310.655 383.313 302.986 382.472 296.258L382.478 296.388C381.358 289.004 381.303 280.965 381.303 280.965C381.266 279.628 381.256 278.419 381.256 277.352C381.256 276.705 381.256 276.108 381.269 275.57C381.303 273.429 381.38 272.164 381.389 271.985V271.963L385.862 272.569L388.12 272.947C388.105 273.145 388.096 273.346 388.096 273.547C388.096 278.023 391.854 281.648 396.488 281.648C400.355 281.648 403.606 279.13 404.58 275.7L406.993 276.102L410.674 276.749V276.764C410.665 276.891 410.566 278.697 410.578 281.602C410.578 281.602 410.792 289.793 411.138 292.955C411.574 297.437 412.31 302.402 413.557 307.255C413.563 307.271 413.566 307.283 413.569 307.298C414.04 309.207 414.105 309.266 414.108 309.266C415.357 313.587 417.04 317.745 419.304 321.305L419.301 321.308Z",
    fill: "#F8B42B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.227 314.311C428.769 314.311 434.883 308.197 434.883 300.655C434.883 293.114 428.769 287 421.227 287C413.686 287 407.572 293.114 407.572 300.655C407.572 308.197 413.686 314.311 421.227 314.311ZM421.227 314.811C429.045 314.811 435.383 308.473 435.383 300.655C435.383 292.838 429.045 286.5 421.227 286.5C413.41 286.5 407.072 292.838 407.072 300.655C407.072 308.473 413.41 314.811 421.227 314.811Z",
    fill: "url(#paint6_linear_1_229)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1_229)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 435,
    y: 395.158,
    width: 298.207,
    height: 56.6216,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514 393.391L521.322 388.158L569.5 455.571L562.178 460.804L514 393.391Z",
    fill: "#0047AB",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518 393.391L525.322 388.158L573.5 455.571L566.178 460.804L518 393.391Z",
    fill: "#0047AB",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518 393.391L681.718 276.388L788.856 426.304L625.139 543.306L518 393.391Z",
    fill: "#0047AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.604 433.158L710.7 428.098H709.028V433.158H705.508V417.758H711.668C714.594 417.758 716.948 420.112 716.948 423.038C716.948 424.93 715.804 426.646 714.11 427.504L717.388 433.158H713.604ZM709.028 421.058V425.018H711.668C712.636 425.018 713.428 424.16 713.428 423.038C713.428 421.916 712.636 421.058 711.668 421.058H709.028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.362 429.77H703.522V433.158H693.842V417.758H703.412V421.146H697.362V423.698H702.862V427.042H697.362V429.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.676 417.758H691.196V433.158H687.676V417.758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.135 417.758V421.146H682.175V433.158H678.655V421.146H674.695V417.758H686.135Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.648 417.758V433.158H664.128V424.204L660.146 430.738H659.75L655.768 424.204V433.158H652.248V417.758H655.768L659.948 424.6L664.128 417.758H667.648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.769 433.466C640.381 433.466 637.829 431.486 637.829 428.186V417.758H641.349V427.878C641.349 429.044 641.899 430.034 643.769 430.034C645.639 430.034 646.189 429.044 646.189 427.878V417.758H649.709V428.186C649.709 431.486 647.157 433.466 643.769 433.466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.781 417.758H635.301V433.158H632.661L626.721 424.798V433.158H623.201V417.758H625.841L631.781 426.118V417.758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.035 417.758H620.555V433.158H617.035V417.758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.494 417.758V421.146H611.534V433.158H608.014V421.146H604.054V417.758H615.494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.087 433.158L600.317 430.738H594.597L593.827 433.158H589.977L595.213 417.758H599.701L604.937 433.158H601.087ZM595.653 427.438H599.261L597.457 421.784L595.653 427.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.817 429.77H589.317V433.158H580.297V417.758H583.817V429.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.15 417.758C576.186 417.758 578.54 420.112 578.54 423.038C578.54 425.964 576.186 428.318 573.15 428.318H570.84V433.158H567.32V417.758H573.15ZM573.15 425.018C574.228 425.018 575.02 424.16 575.02 423.038C575.02 421.916 574.228 421.058 573.15 421.058H570.84V425.018H573.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_1_229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.678 422.605C503.078 423.032 499.23 420.324 498.493 420.318C497.756 420.312 493.864 422.958 493.271 422.521C492.678 422.084 494.072 417.598 493.85 416.897C493.628 416.196 489.901 413.323 490.135 412.626C490.368 411.928 495.078 411.864 495.678 411.436C496.278 411.009 497.867 406.588 498.604 406.594C499.341 406.599 500.858 411.046 501.451 411.483C502.044 411.92 506.752 412.06 506.974 412.761C507.196 413.462 503.424 416.275 503.19 416.972C502.957 417.669 504.278 422.178 503.678 422.605Z",
    fill: "url(#paint7_linear_1_229)"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 435.25,
    y: 395.408,
    width: 297.707,
    height: 56.1216,
    rx: 9.75,
    stroke: "url(#paint8_linear_1_229)",
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M486.217 424.28L479.214 420.889L471.31 430.315L469.983 428.431L471.635 415.761L465.093 396.068L450.099 401.377L454.093 411.43L466.927 442.326L469.757 449.327L470.085 447.294L473.213 435.369L477.584 430.516L485.388 429.916L472.959 421.313L486.217 424.28Z",
    fill: "#010101",
    fillOpacity: 0.3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M474.144 387.203C478.781 387.203 482.539 383.576 482.539 379.101C482.539 374.627 478.781 371 474.144 371C469.507 371 465.749 374.627 465.749 379.101C465.749 383.576 469.507 387.203 474.144 387.203Z",
    fill: "#C2C2C2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M496.301 436.006L491.194 438.571C489.709 435.747 486.56 433.875 482.994 434.16C478.821 434.494 475.492 437.85 475.319 441.887C475.254 443.393 475.613 444.816 476.3 446.048L475.953 446.221L473.225 447.588L469.76 449.326C467.972 445.29 466.46 441.237 465.182 437.238C464.975 436.597 464.774 435.951 464.582 435.31V435.304C464.44 434.834 464.298 434.352 464.189 433.977C464.081 433.606 464.007 433.349 464.007 433.349C461.715 425.353 460.313 417.685 459.472 410.957L459.478 411.086C458.358 403.703 458.303 395.663 458.303 395.663C458.266 394.327 458.256 393.117 458.256 392.05C458.256 391.403 458.256 390.806 458.269 390.268C458.303 388.128 458.38 386.862 458.389 386.683V386.661L462.862 387.268L465.12 387.645C465.105 387.843 465.096 388.044 465.096 388.245C465.096 392.721 468.854 396.347 473.488 396.347C477.355 396.347 480.606 393.829 481.58 390.398L483.993 390.8L487.674 391.447V391.462C487.665 391.589 487.566 393.396 487.578 396.3C487.578 396.3 487.792 404.491 488.138 407.653C488.574 412.135 489.31 417.1 490.557 421.953C490.563 421.969 490.566 421.981 490.569 421.997C491.04 423.905 491.105 423.964 491.108 423.964C492.357 428.285 494.04 432.443 496.304 436.003L496.301 436.006Z",
    fill: "#0047AB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M498.227 428.631C505.769 428.631 511.883 422.517 511.883 414.975C511.883 407.434 505.769 401.32 498.227 401.32C490.686 401.32 484.572 407.434 484.572 414.975C484.572 422.517 490.686 428.631 498.227 428.631ZM498.227 429.131C506.045 429.131 512.383 422.793 512.383 414.975C512.383 407.158 506.045 400.82 498.227 400.82C490.41 400.82 484.072 407.158 484.072 414.975C484.072 422.793 490.41 429.131 498.227 429.131Z",
    fill: "url(#paint9_linear_1_229)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_229",
    x1: 315.124,
    y1: 196.843,
    x2: 331.983,
    y2: 196.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_229",
    x1: 260,
    y1: 206,
    x2: 396.1,
    y2: 235.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_229",
    x1: 323.227,
    y1: 183.198,
    x2: 323.227,
    y2: 211.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_229",
    x1: 413.124,
    y1: 299.843,
    x2: 429.983,
    y2: 299.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_229",
    x1: 413.124,
    y1: 299.843,
    x2: 429.983,
    y2: 299.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A928"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_229",
    x1: 358,
    y1: 309,
    x2: 494.5,
    y2: 337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA619"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_229",
    x1: 421.227,
    y1: 286.5,
    x2: 421.227,
    y2: 314.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8B32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99907D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_229",
    x1: 490.124,
    y1: 414.622,
    x2: 506.983,
    y2: 414.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0047AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00357F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_229",
    x1: 435,
    y1: 423.779,
    x2: 584.104,
    y2: 451.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0047AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_229",
    x1: 498.227,
    y1: 400.82,
    x2: 498.227,
    y2: 429.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0047AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_229"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 178,
    width: 273,
    height: 56,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_229"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 281,
    width: 273,
    height: 56,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1_229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(412 291)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1_229"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 435,
    y: 395.158,
    width: 298.207,
    height: 56.6216,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_1_229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(489 405.779)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembership);
export default __webpack_public_path__ + "static/media/Membership.115924dd048a678c99597321655dd79a.svg";
export { ForwardRef as ReactComponent };